export const LOAD_UPDATES_INCREMENT = 20;
export const DUE_SOON_ID_PREFIX = 'due-soon-card';
export const UPDATE_ID_PREFIX = 'update-card';
